function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _invert from 'lodash/invert';
export var countryMap = {
    US: 'United States',
    CA: 'Canada',
    JM: 'Jamaica',
    VC: 'Saint Vincent and the Grenadines',
    PR: 'Puerto Rico'
};
export var JamaicanParishesMap = {
    '01': 'Kingston Parish',
    '02': 'St. Andrew Parish',
    '03': 'St. Thomas Parish',
    '04': 'Portland Parish',
    '05': 'St. Mary Parish',
    '06': 'St. Ann Parish',
    '07': 'Trelawny Parish',
    '08': 'St. James Parish',
    '09': 'Hanover Parish',
    10: 'Westmoreland Parish',
    11: 'St. Elizabeth Parish',
    12: 'Manchester Parish',
    13: 'Clarendon',
    14: 'St. Catherine Parish'
};
export var saintVincentAndTheGrenadinesParishesMap = {
    VC: 'St. Vincent and the Grenadines'
};
export var countryMapToShortened = _invert(countryMap);
export var canadianProvincesMap = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Québec',
    SK: 'Saskatchewan',
    YT: 'Yukon'
};
export var puertoRicoMap = {
    Humacao: 'Humacao',
    Naguabo: 'Naguabo'
};
export var canadianProvincesMapToShortened = _object_spread_props(_object_spread({}, _invert(canadianProvincesMap)), {
    Quebec: 'QC'
});
export var USStatesMap = {
    AL: 'Alabama',
    AK: 'Alaska',
    AR: 'Arkansas',
    AS: 'American Samoa',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    'San Juan': 'San Juan',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming'
};
export var USStatesMapToShortened = _object_spread_props(_object_spread({}, _invert(USStatesMap)), {
    DC: 'DC'
});
export var statesMap = _object_spread({}, USStatesMap, canadianProvincesMap, saintVincentAndTheGrenadinesParishesMap, puertoRicoMap);
export var supportedCountries = [
    'US',
    'PR',
    'CA',
    'JM',
    'VC'
];
